import {AfterContentInit, Component, OnInit} from '@angular/core';
import {AuthService} from "./modules/shared/services/auth.service";
import {LocalStorageService} from "./modules/shared/services/local-storage.service";
import {ModalService} from "./modules/shared/services/modal.service";
import {Store} from "@ngrx/store";
import {GetCompany, GetSubscription} from "./modules/shared/store/store.actions";
import Intercom from "@intercom/messenger-js-sdk";
import {RestaurantService} from "./modules/shared/services/restaurant.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ModalService]
})
export class AppComponent implements OnInit, AfterContentInit {
  constructor(
      private authService: AuthService,
      private localStorage: LocalStorageService,
      private modalService: ModalService,
      private store: Store,
      private restaurantService: RestaurantService
  ) {
  }

  ngOnInit(): void {
    if (this.authService.isLogged()) {

      this.store.dispatch(GetCompany())
      this.store.dispatch(GetSubscription())

      Intercom({
        app_id: 'yy3ni07n',
        user_id: this.authService.getUser().id.toString(),
        name: this.restaurantService.currentRestaurant?.name || this.authService.getUser().email,
        email: this.authService.getUser().email,
        api_base: 'https://api-iam.eu.intercom.io'
      });
    }
  }

  ngAfterContentInit(): void {

  }
}
